import { Table } from 'react-bootstrap';
import { createClaimsTable } from '../../utils/claimUtils';

export const IdTokenData = (props) => {
    const tokenClaims = createClaimsTable(props.idTokenClaims);

    const tableRow = Object.keys(tokenClaims).map((key) => {
        const [claimType, rawValue, description] = tokenClaims[key];

        let renderedValue;
        if (Array.isArray(rawValue)) {
            renderedValue = rawValue.join(', ');
        } else if (rawValue && typeof rawValue === 'object') {
            renderedValue = JSON.stringify(rawValue);
        } else {
            renderedValue = rawValue;
        }

        return (
            <tr key={claimType}>
                <td>{claimType}</td>
                <td>{renderedValue}</td>
                <td>{description}</td>
            </tr>
        );
    });
    
    return (
        <>
            <div className="data-area-div">
                <p>
                    See below the claims in your <strong> ID token </strong>. For more information, visit:{' '}
                    <span>
                        <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token">
                            docs.microsoft.com
                        </a>
                    </span>
                </p>
                <div className="data-area-div">
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Claim</th>
                                <th>Value</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>{tableRow}</tbody>
                    </Table>
                </div>
            </div>
        </>
    );
};
